import { TranslationFunction } from '@/src/types/translations'
import { Box, Dialog, DialogContent, Typography } from '@mui/material'
import React from 'react'

interface CashbackScheduleModalProps {
    open: boolean
    onClose: () => void
    message: string
    currency: string
    breakup: Array<{
        date: string
        message?: string
        amount: number
    }>
    formatCurrency: (amount: number) => string
    t: TranslationFunction<'couponTray'>
}

const CashbackScheduleModal: React.FC<CashbackScheduleModalProps> = ({
    open,
    onClose,
    message,
    currency,
    breakup,
    formatCurrency,
    t
}) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 3,
                    m: 2,
                    maxWidth: 420
                }
            }}
        >
            <DialogContent sx={{ p: 0 }}>
                <Box sx={{ p: 3 }}>
                    <Box sx={{ mb: 3, textAlign: 'center' }}>
                        <Typography
                            variant="h6"
                            sx={{
                                fontWeight: 600,
                                fontSize: 20,
                                color: 'text.primary'
                            }}
                        >
                            {t('cashbackSchedule')}
                        </Typography>
                    </Box>

                    <Typography
                        sx={{
                            fontSize: 14,
                            color: 'text.secondary',
                            textAlign: 'center',
                            mb: 4
                        }}
                    >
                        {message}
                    </Typography>

                    <Box sx={{ mb: 4 }}>
                        {breakup &&
                            breakup.length > 0 &&
                            breakup.map((item, idx) => (
                                <Box
                                    key={idx}
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'flex-start',
                                        mb: idx !== breakup.length - 1 ? 3 : 0,
                                        position: 'relative',
                                        pl: 4
                                    }}
                                >
                                    <Box
                                        sx={{
                                            position: 'absolute',
                                            left: 0,
                                            top: '8px',
                                            width: 12,
                                            height: 12,
                                            borderRadius: '50%',
                                            border: '3px solid',
                                            borderColor: 'primary.main',
                                            bgcolor: 'background.paper',
                                            zIndex: 1
                                        }}
                                    />
                                    {idx !== breakup.length - 1 && (
                                        <Box
                                            sx={{
                                                position: 'absolute',
                                                left: '5px',
                                                top: '20px',
                                                bottom: '-24px',
                                                width: 2,
                                                bgcolor: 'divider'
                                            }}
                                        />
                                    )}
                                    <Box sx={{ flex: 1 }}>
                                        <Typography
                                            sx={{
                                                fontSize: 12,
                                                color: 'text.secondary',
                                                mb: 0.5
                                            }}
                                        >
                                            {item.message || item.date}
                                        </Typography>
                                        <Typography
                                            sx={{
                                                fontSize: 16,
                                                fontWeight: 600,
                                                color: 'text.primary'
                                            }}
                                        >
                                            {formatCurrency(item.amount)}
                                        </Typography>
                                    </Box>
                                </Box>
                            ))}
                    </Box>

                    <Box sx={{ textAlign: 'center' }}>
                        <Typography
                            onClick={onClose}
                            sx={{
                                color: 'primary.main',
                                fontSize: 14,
                                fontWeight: 500,
                                cursor: 'pointer',
                                display: 'inline-block',
                                '&:hover': {
                                    textDecoration: 'underline'
                                }
                            }}
                        >
                            {t('close')}
                        </Typography>
                    </Box>
                </Box>
            </DialogContent>
        </Dialog>
    )
}

export { CashbackScheduleModal }
export type { CashbackScheduleModalProps }
